import type { Directive } from 'vue'

export const defaultSets = [
  '320',
  '480',
  '640',
  '960',
  '1280',
  '1440',
  '1600',
  '1920',
  '2240',
  '2560',
  '2880',
] as const

type SetSize = (typeof defaultSets)[number]
type Sets = Record<SetSize, string>
interface VueSrcData {
  src: string
  rawUrl: string
  sets: Sets
  alt: string
  caption: string
  description: string
}

const directive: Directive<HTMLImageElement, VueSrcData> = {
  created(el, binding, vnode) {
    if (el.hasAttribute('src')) {
      return
    }

    const { src, sets, alt } = binding.value

    el.setAttribute('src', src)

    if (!el.hasAttribute('alt')) {
      el.setAttribute('alt', alt)
    }

    if (!sets) {
      return
    }

    const customSets = vnode.props
      ? (vnode.props as { sets?: SetSize[] }).sets || defaultSets
      : defaultSets

    let srcset = ''

    customSets?.forEach(size => {
      const url = sets[size]

      if (url) {
        srcset += `${url} ${size}w,`
      }
    })

    srcset = srcset.replace(/,$/, '')

    el.setAttribute('srcset', srcset)
  },
}

export default directive
